$(document).ready(function() {
  setTimeout(() => {
    $('#registration_invoice_company_name').attr('autocomplete', 'hidden');
  }, 800);
});

(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
  key: "AIzaSyC8KFwloz17NtJMzo7zlnFdX9pD_F3KqFc",
  v: "weekly",
});

let gmInputElement = document.getElementById('registration_invoice_company_name');
let $gmWrapperElement = $('.form-item--with-suggestions');
let $gmResultElement = $('#gm_ResultContainer');
let $gmResultOutputPlace = $('#registration_invoice_company_name');
let $gmResultOutputWeb = $('#registration_invoice_website');
let $gmResultOutputStreet = $('#registration_invoice_address1_street');
let $gmResultOutputNr = $('#registration_invoice_address1_nr');
let $gmResultOutputZip = $('#registration_invoice_zip');
let $gmResultOutputCity = $('#registration_invoice_city');
let $gmResultOutputCountry = $('#registration_invoice_country');
let gmGeoSet = 0;
let gmRequestId = 0;
let gmRequest = {
  input: '',
  includedPrimaryTypes: ['establishment'],
  locationBias: {}
};

async function initGAutoComplete() {
  await google.maps.importLibrary('places');
  tokenGAutoComplete();
  gmInputElement.addEventListener('focus', geoGAutoComplete);
  gmInputElement.addEventListener('input', makeGAutoRequest);
}

function geoGAutoComplete(){
  if(gmGeoSet == 0){
    if(navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        if(position){
          gmRequest.locationBias = {
            center: { lat: position.coords.latitude, lng: position.coords.longitude }, 
            radius: position.coords.accuracy
          }
        }
        gmGeoSet = 1;
      });
    }
  }
}
function countGAutocomplete(){
  let gmResultCount = $gmResultElement.find('a').length;
  if(gmResultCount > 0){
    showGAutoComplete();
  } else {
    hideGAutoComplete();
  }
}
function showGAutoComplete(){
  $gmWrapperElement.addClass('show--results');
}
function hideGAutoComplete(){
  $gmWrapperElement.removeClass('show--results');
}
function resetGAutoComplete(){
  $gmResultElement.html('');
}
function weburiGAutoComplete(gmInputUri){
  let gmInputUriArr = gmInputUri.split('?');
  let gmOutputUri = gmInputUriArr.shift();
  gmOutputUri = gmOutputUri.replace('http://','https://');
  return gmOutputUri;
}
function textGAutoComplete(gmInputTxt){
  let gmOutputTxt = '';
  let gmInputTxtArr = gmInputTxt.split(',');
  let gmInputTxtComp = gmInputTxtArr.shift();
  let gmInputTxtRest = gmInputTxtArr.join(',');
  gmOutputTxt = '<strong>' + gmInputTxtComp + '</strong>' + gmInputTxtRest;
  return gmOutputTxt;
}
function linkGAutoComplete(suggestion){
  const gmPlacePrediction = suggestion.placePrediction;
  const gmPlaceText = gmPlacePrediction.text.toString();
  const gmPlaceLink = document.createElement('a');
  gmPlaceLink.innerHTML = textGAutoComplete(gmPlaceText);
  let gmPlacePlace = gmPlacePrediction.toPlace();
  gmPlaceLink.addEventListener('mousedown', (event) => {
    selectGAutoComplete(gmPlacePlace);
  });
  $gmResultElement.append(gmPlaceLink);
}
function clearGAutocomplete(){
  $gmResultOutputStreet.val('');
  $gmResultOutputNr.val('');
  $gmResultOutputZip.val('');
  $gmResultOutputCity.val('');
  $gmResultOutputWeb.val('');
}
async function selectGAutoComplete(gmSelectedPlace){
  clearGAutocomplete();
  await gmSelectedPlace.fetchFields({
    fields: ['displayName', 'addressComponents', 'websiteURI'],
  });
  if(gmSelectedPlace.displayName){
    $gmResultOutputPlace.val(gmSelectedPlace.displayName);
  }
  if(gmSelectedPlace.websiteURI){
    $gmResultOutputWeb.val(weburiGAutoComplete(gmSelectedPlace.websiteURI));
  }
  for(let i = 0; i < gmSelectedPlace.addressComponents.length; i++) {
    let gmSelPlaceType = gmSelectedPlace.addressComponents[i].types[0];
    let gmSelPlaceVal = gmSelectedPlace.addressComponents[i].longText;
    let gmSelPlaceShortVal = gmSelectedPlace.addressComponents[i].shortText;
    if(gmSelPlaceType == 'route'){
      $gmResultOutputStreet.val(gmSelPlaceVal);
    } else if(gmSelPlaceType == 'street_number'){
      $gmResultOutputNr.val(gmSelPlaceVal);
    } else if(gmSelPlaceType == 'postal_code'){
      $gmResultOutputZip.val(gmSelPlaceVal);
    } else if(gmSelPlaceType == 'administrative_area_level_2'){
      $gmResultOutputCity.val(gmSelPlaceVal);
    } else if(gmSelPlaceType == 'country'){
      $gmResultOutputCountry.find('option[value="'+gmSelPlaceShortVal+'"]').prop('selected', true).trigger('change');
    }
  }
  tokenGAutoComplete();
}
function fillGAutoComplete(suggestions){
  resetGAutoComplete();
  for (const suggestion of suggestions){
    linkGAutoComplete(suggestion);
  }
  countGAutocomplete();
}

function tokenGAutoComplete(){
  gmRequest.sessionToken = new google.maps.places.AutocompleteSessionToken();
}

async function makeGAutoRequest(gmInputEvent) {
  if(gmInputEvent.target.value == ''){
    resetGAutoComplete();
    countGAutocomplete();
    return;
  }
  gmRequest.input = gmInputEvent.target.value;
  const gmCheckRequestId = ++gmRequestId;
  const { suggestions  } = await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(gmRequest); 
  if(gmCheckRequestId !== gmRequestId){
    return;
  }
  fillGAutoComplete(suggestions);
}

$gmWrapperElement.on("focusout", function() {
  setTimeout(() => {
    hideGAutoComplete();
  }, 200);
});

$gmWrapperElement.on("focusin", function() {
  countGAutocomplete();
});

$('#registration_invoice_company_name').on('keydown', function(event) {
  if (event.key === 'Tab') {
    hideGAutoComplete();
  }
});

initGAutoComplete();